import * as React from 'react'
import { SignOutButtonConnected } from './SignOutButtonConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const SignOutButtonExamples = () => {
  return (
    <div className="SignOutButtonExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <SignOutButtonConnected />
      </Provider>
    </div>
  )
}
